export default "__VITE_ASSET__d5806a54__"